/**-----------------------------------------------------------------------------------------
* Copyright © 2023 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the package root for more information
*-------------------------------------------------------------------------------------------*/
"use client";
import * as e from "react";
import r from "prop-types";
import { validatePackage as B, useRtl as H, Keys as N, classNames as R, IconWrap as V } from "@progress/kendo-react-common";
import { chevronRightIcon as I, chevronLeftIcon as D } from "@progress/kendo-svg-icons";
const $ = {
  name: "@progress/kendo-react-scrollview",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1702645172,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/components/my-license/"
}, d = e.forwardRef((f, K) => {
  B($);
  const {
    className: h,
    style: P,
    children: k,
    pagerOverlay: w,
    pageable: T,
    arrows: x,
    endless: n,
    activeView: O,
    automaticViewChange: C,
    automaticViewChangeInterval: y
  } = f, [t, s] = e.useState(O || 1), o = e.useRef(null), m = e.useRef(null), g = e.useRef(null), a = e.Children.toArray(k), p = H(o, f.dir), c = p === "rtl", b = e.useCallback(
    () => {
      o.current && o.current.focus();
    },
    []
  ), A = e.useCallback(
    () => ({
      element: o.current,
      focus: b
    }),
    [b]
  );
  e.useImperativeHandle(K, A);
  const u = e.useCallback(() => {
    n ? t > 1 ? s(t - 1) : s(a.length) : t > 1 && s(t - 1);
  }, [t, a.length, n]), v = e.useCallback(() => {
    n ? t < a.length ? s(t + 1) : s(1) : t < a.length && s(t + 1);
  }, [t, a.length, n]);
  e.useEffect(() => {
    let l = a.length;
    m.current && (m.current.style.setProperty("--kendo-scrollview-views", `${l}`), m.current.style.setProperty("--kendo-scrollview-current", `${t}`));
  }, [a, t, p]);
  function E() {
    g.current && clearTimeout(g.current);
  }
  e.useEffect(() => {
    if (C)
      return E(), g.current = setTimeout(
        () => s((l) => l === a.length ? n ? 1 : l : l + 1),
        y
      ), () => {
        E();
      };
  }, [C, y, a.length, t, n]);
  const L = e.useCallback(
    (l) => {
      switch (l.keyCode) {
        case N.left:
          l.preventDefault(), c ? v() : u();
          break;
        case N.right:
          l.preventDefault(), c ? u() : v();
          break;
      }
    },
    [c, v, u]
  ), M = e.useMemo(
    () => R(
      "k-scrollview",
      {
        "k-scrollview-light": w === "light",
        "k-scrollview-dark": w === "dark"
      },
      h
    ),
    [h, w]
  ), S = e.Children.map(k || null, (l, i) => /* @__PURE__ */ e.createElement(
    "div",
    {
      className: "k-scrollview-view",
      "aria-hidden": t !== i + 1
    },
    l
  )), U = e.useCallback(() => {
    let l;
    return l = t > 1, (n || l) && a.length > 0;
  }, [t, a.length, n]), z = e.useCallback(() => {
    let l;
    return l = t < a.length, (n || l) && a.length > 0;
  }, [t, a.length, n]);
  return /* @__PURE__ */ e.createElement("div", { className: M, style: P, ref: o, tabIndex: 0, dir: p, onKeyDown: L }, /* @__PURE__ */ e.createElement("div", { className: "k-scrollview-wrap k-scrollview-animate", ref: m }, S), /* @__PURE__ */ e.createElement("div", { className: "k-scrollview-elements" }, x && /* @__PURE__ */ e.createElement(e.Fragment, null, U() && /* @__PURE__ */ e.createElement("span", { className: "k-scrollview-prev", "aria-label": "previous", onClick: u }, /* @__PURE__ */ e.createElement(
    V,
    {
      name: c ? "chevron-right" : "chevron-left",
      icon: c ? I : D,
      size: "xxxlarge"
    }
  )), z() && /* @__PURE__ */ e.createElement("span", { className: "k-scrollview-next", onClick: v }, /* @__PURE__ */ e.createElement(
    V,
    {
      name: c ? "chevron-left" : "chevron-right",
      icon: c ? D : I,
      size: "xxxlarge"
    }
  ))), T && /* @__PURE__ */ e.createElement("div", { className: "k-scrollview-nav-wrap" }, /* @__PURE__ */ e.createElement("div", { className: "k-scrollview-nav" }, a.map((l, i) => /* @__PURE__ */ e.createElement(
    "span",
    {
      className: R(
        "k-link",
        {
          "k-primary": t === i + 1
        }
      ),
      key: i + 1,
      onClick: () => s(i + 1)
    }
  ))))));
});
d.propTypes = {
  activeView: r.number,
  arrows: r.bool,
  automaticViewChange: r.bool,
  automaticViewChangeInterval: r.number,
  children: r.any,
  className: r.string,
  dir: r.string,
  endless: r.bool,
  pageable: r.bool,
  pageOverlay: r.string,
  style: r.object
};
const j = {
  activeView: 1,
  arrows: !0,
  automaticViewChange: !0,
  automaticViewChangeInterval: 5e3,
  endless: !1,
  pageable: !0,
  pageOverlay: "none"
};
d.defaultProps = j;
d.displayName = "KendoScrollView";
export {
  d as ScrollView
};
